import { render, staticRenderFns } from "./DataViewSidebarStaffHasEquipments.vue?vue&type=template&id=e81d5b66&scoped=true&"
import script from "./DataViewSidebarStaffHasEquipments.vue?vue&type=script&lang=js&"
export * from "./DataViewSidebarStaffHasEquipments.vue?vue&type=script&lang=js&"
import style0 from "./DataViewSidebarStaffHasEquipments.vue?vue&type=style&index=0&id=e81d5b66&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e81d5b66",
  null
  
)

export default component.exports